import { useFormContext, useController } from 'react-hook-form';

import { FormField } from 'ui/formField';
import { TileRadio } from 'ui/radio/TileRadio';
import { IdType } from 'modules/domains/adminApp';

import { TileRadioGrid } from './TileRadioGrid';
import { FormFieldKey } from './types';
import { createPatternValidatorForEnum } from './utils/createPatternValidatorForEnum';
import {
  ALL_ORGS_OPTION,
  ALL_PROJECTS_OPTION,
  ID_TYPE_INPUT_LABEL,
  VALIDATION_MSG_ID_TYPE_REQUIRED,
} from './constants';

export const EntityTypeInput = () => {
  const { control } = useFormContext();
  const {
    field: { name, onChange, value: selection },
    fieldState: {
      error: { message: errorMessage } = {},
    },
  } = useController({
    name: FormFieldKey.IdType,
    control,
    rules: {
      required: VALIDATION_MSG_ID_TYPE_REQUIRED,
      pattern: createPatternValidatorForEnum(IdType),
    },
  });

  const createProps = (value: IdType) => ({
    name,
    value,
    onClick: () => onChange({ target: { value } }),
    isChecked: selection === value,
  });

  return (
    <FormField
      labelText={ID_TYPE_INPUT_LABEL}
      hasError={!!errorMessage}
      errorText={errorMessage}
      isRequired
    >
      <TileRadioGrid>
        <TileRadio {...createProps(IdType.Project)}>{ALL_PROJECTS_OPTION}</TileRadio>
        <TileRadio {...createProps(IdType.Organization)}>{ALL_ORGS_OPTION}</TileRadio>
      </TileRadioGrid>
    </FormField>
  );
};
